export default __webpack_public_path__ + "/dist/images/check_img_yellow.8f7cae09f7ec002666dee90336094e41.svg";